
<template>
    <details>
            <summary>
                <div>
                    <vs-row>
                        <vs-col sm="12" lg="7">
                            <div class="info">
                                <span class="mr-3">
                                    <i style="font-size: 18px" class="fas fa-long-arrow-alt-down"></i>
                                </span>
                                <div>
                                    <h5><strong class="mb-2">{{tr.nombre}}</strong></h5>
                                    <div class="d-flex">
                                        <div class="mr-4">
                                            <span><small>MATRÍCULA: </small></span>
                                            <span><strong>{{tr.matricula}}</strong></span>
                                        </div>
                                        <div>
                                            <span><small>GRADO: </small></span>
                                            <span><strong>{{tr.grado}}</strong></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="5">
                            <div class="borderTarjeta py-2 px-3">
                                <vs-row>
                                    <vs-col w="6">
                                        <h6 class="mb-0"><span><small>BECA</small></span></h6>
                                        <h6 class="mb-0"><span class="mb-2"><strong>{{tr.beca_nombre}}</strong></span></h6>
                                    </vs-col>
                                    <vs-col w="6" class="">
                                        <span><small>PROCENTAJE: </small></span>
                                        <span class="mb-2"><strong>{{tr.beca_porcentaje}}</strong></span>
                                        <span><small>ALCANCE: </small></span>
                                        <span><strong>{{tr.beca_alcance}}</strong></span>
                                    </vs-col>
                                </vs-row>
                            </div>
                        </vs-col>
                    </vs-row>
                    <!-- <vs-row>
                        <vs-col w="4" class="info">
                            <span class="mr-3">
                                <i style="font-size: 18px" class="far fa-caret-square-down"></i>
                            </span>
                            <h6>
                                <strong class="mb-2">{{tr.nombre}}</strong>
                                <span><small>MATRÍCULA: </small></span>
                                <span><strong>{{tr.matricula}}</strong></span>
                            </h6>
                        </vs-col>
                        <vs-col w="4" class="info">
                            <h6>
                                <span><small>CICLO ESCOLAR: </small></span>
                                <span class="mb-2"><strong>{{tr.ciclo_escolar}}</strong></span>
                                <span><small>PROGRAMA: </small></span>
                                <span class="mb-2"><strong>{{tr.programa}}</strong></span>
                                <span><small>GRADO: </small></span>
                                <span><strong>{{tr.grado}}</strong></span>
                            </h6>
                        </vs-col>
                        <vs-col w="4" class="info">
                            <h6>
                                <span><small>NOMBRE DE BECA: </small></span>
                                <span class="mb-2"><strong>{{tr.beca_nombre}}</strong></span>
                                <span><small>PROCENTAJE: </small></span>
                                <span class="mb-2"><strong>{{tr.beca_porcentaje}}</strong></span>
                                <span><small>ALCANCE: </small></span>
                                <span><strong>{{tr.beca_alcance}}</strong></span>
                            </h6>
                        </vs-col>
                    </vs-row> -->
                </div>
            </summary>
            <div>
                <vs-row>
                    <vs-col w="3" v-if="tr.cargos.length">
                        <div style="padding: 4px 10px; cursor: pointer" @click="getPestanasTipo('cargos', tr)" :class="tipoCategoria == 'cargos' ? 'colorTag' : 'borderTag'" >
                            <strong>CARGOS</strong>
                        </div>
                    </vs-col>
                    <vs-col w="3" v-if="tr.pagos.length">
                        <div style="padding: 4px 10px; cursor: pointer" @click="getPestanasTipo('pagos', tr)" :class="tipoCategoria == 'pagos' ? 'colorTag' : 'borderTag'" >
                            <strong>PAGOS</strong>
                        </div>
                    </vs-col>
                    <vs-col w="3" v-if="tr.becas.length">
                        <div style="padding: 4px 10px; cursor: pointer" @click="getPestanasTipo('becas', tr)" :class="tipoCategoria == 'becas' ? 'colorTag' : 'borderTag'" >
                            <strong>BECAS</strong>
                        </div>
                        
                    </vs-col>
                    <vs-col w="3" v-if="tr.descuentos.length">
                        <div style="padding: 4px 10px; cursor: pointer" @click="getPestanasTipo('descuentos', tr)" :class="tipoCategoria == 'descuentos' ? 'colorTag' : 'borderTag'" >
                            <strong>DESCUENTOS</strong>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-3">
                    <!-- <vs-col w="12">
                        <vs-input class="ml-auto" style="width: 30%;" v-model="search" placeholder="Buscar">
                            <template #icon>
                                <i class="fas fa-search"></i>
                            </template>
                        </vs-input>
                    </vs-col> -->
                    <vs-col w="3" v-for="(cargo, c) in getArray(tr, tipoCategoria) " :key="c">
                        <div class="cardIndividual text-center shadow-sm">
                            <p class="mb-0"><strong>{{cargo.codigo_detalle}}</strong></p>
                            <md-chip class="mb-3 fontMedium mini-chip col-blue text-uppercase" ><strong><small>CATEGORÍA: </small>{{cargo.categoria}}</strong></md-chip>
                            <div class="d-flex justify-content-around">
                                <div>
                                    <small>MONTO</small>
                                    <p class="mb-0"><span>
                                        <strong>{{cargo.monto | currency}}</strong>
                                    </span></p>
                                </div>
                                <div>
                                    <small>SALDO</small>
                                    <p class="mb-0"><span>
                                        <strong>{{cargo.saldo_movimiento | currency}}</strong>
                                    </span></p>
                                </div>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
            </div>
    </details>
</template>
<script>
export default {
    props: [
        'tr',
        'index'
    ],
    data:() => ({
        tipoCategoria: 'cargos',
    }),
    methods:{
        getArray(array, tipo){
            if(tipo == 'cargos'){
                return array.cargos
            }
            if(tipo == 'pagos'){
                return array.pagos
            }
            if(tipo == 'becas'){
                return array.becas
            }
            if(tipo == 'descuentos'){
                return array.descuentos
            }
        },
        getBuscador(){
            const info = this.permisos
            info.forEach(i => {
                this.search.push('')
            })
        },
        getPestanasTipo(tipo,array){
            if(tipo == 'cargos'){
                this.tipoCategoria = 'cargos'
            }
            if(tipo == 'pagos'){
                this.tipoCategoria = 'pagos'
            }
            if(tipo == 'becas'){
                this.tipoCategoria = 'becas'
            }
            if(tipo == 'descuentos'){
                this.tipoCategoria = 'descuentos'
            }
            this.getArray(array, tipo)
            this.forceRerender()
        },
        getPestana(){
            this.detalle.forEach(i => {
                this.tipoCategoria.push('cargos')
                this.componentKey.push(0)
            })
        },
        forceRerender() {
            this.componentKey += 1;
        } 
    },
    watch:{
        detalle(){
            this.getPestana()
        },
    }
}
</script>

<style lang="scss" scoped >
.borderTarjeta{
    border-left: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 7px;
}
.cardBorder{
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
}
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('blue', #2d8bf6, #deecfc ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);  
    @include text-colors ('blue', #92bff1, #c7e1ff ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

.col-purple{
    color: purple;
    background: rgb(234, 228, 236);
}
.fontBiger{
    font-size: 22px;
}
.fontBig{
    font-size: 16px;
}
.fontMedium{
    font-size: 15px;
}

.fontSmall{
    font-size: 12px;
}

.breakInfo{
    word-break: break-all;
}
summary {
	background-color: #fff;
	position: relative;
	cursor: pointer;
    padding: 10px 12px;
    border-bottom: 1px solid #f2f5f9;
	list-style: none; // Remove arrow
	&::-webkit-details-marker {
		display: none; // Remove arrow
	}
	
	&:hover {
		background-color: #f2f5f9;
	}
    .info {
        display: flex !important;
        align-items: center;
	}
    .info h6 {
		display: flex;
		flex-direction: column;
	}
}
details {
    margin-top: 1%;
	border-bottom: 1px solid rgba(0, 0, 0, 0.125);
	
	// &:first-of-type {
	// 	border-top: 1px solid #cad5f1;
	// }
	& > div {
		padding: 2em 2em;
		font-size: .875em;
	}
}
.permisos{
    .encabezado{
        border-radius: 14px 14px 0 0;
        background: #F4F7F8;
        padding: 10px 12px;
    }
    .sinInfo{
        padding: 20px;
        text-align: center;
    }
    details{
        padding: 0;
    }
    details:not(:last-child){
        border-bottom: 2px solid #ececec;
    }
    details summary{
    font-size: 15px;
    }
}
</style>
<style scoped>
  .divisionLineasTop:not(:first-child){
      border-top: 1px solid #E5E7E9; 
  }
  .divisionLineasTop{
      padding: 2% 0;
  }
  .borderMes{
    background: white;
    border: 1px solid #E5E7E9; 
    padding: 4%;
    margin: 3% 5%;
    border-radius: 8px;
  }
  .cardIndividual{
    border: 1px solid #efefef;
    border-radius: 7px;
    padding: 6px 8px;
    margin:5px;
  }
  .colorTag{
    border-bottom: 2px solid #d8daeb;
    padding: 4px 10px;
    background: #f0f2ff;
    color: black;
    border-radius: 5px 60px 10px 5px;
  }
  .borderTag{
    border-bottom: 2px solid #d8daeb;
  }
</style>

